export default __webpack_public_path__ + "assets/images/c_inventory.e365687.jpg";